import React from 'react'
import logo from '../common/logo.png'

export default function Toptitre() {
  return (
    <div className='border-bottom white topbg'>
        <img src={logo} alt="" className="navbar-brand toplogo rounded-circle img-fluid" />
        <h3><strong>eAgrimetInfo App <i className='bi bi-cloud-lightning-rain'></i></strong></h3>             
        <h4 className='text-end text-warning bg-dark'>Actualit&eacute; M&eacute;t&eacute;o  en Langue 24H/24</h4>
    </div>
  )
}
